import { colors } from '../../../../../styles/color-tokens';
import Chip from '@mui/material/Chip';
import { toCurrencyString } from '@client/toolkit';

export const InfoCard = ({
  name,
  amount,
  chipLabel,
  chipColor = colors.status.success,
}: {
  name: string;
  amount: number;
  chipLabel: string;
  chipColor: string;
}) => {
  return (
    <div className="text-white border border-border bg-surface-selected rounded-md px-4 py-2 flex flex-row gap-2 justify-between items-center">
      <div className="text-sm text-white">{name}</div>
      <div className="flex flex-row gap-4 items-center">
        <Chip
          label={chipLabel}
          size="small"
          sx={{ backgroundColor: chipColor, fontSize: '0.75rem', borderRadius: '0.5rem' }}
        />
        <div className="text-sm text-white">{toCurrencyString(amount, undefined, { currency: 'NOK', maximumFractionDigits: 0 })}</div>
      </div>
    </div>
  );
};
